import { assetsApi } from 'core/api/assets.api';
import { getDateFromMoment } from 'core/constants/globalfunc';
import { setAddCart, setEquipFee, setIsLoading } from 'core/store/slices/settingSlice';
import { useGetAccessToken } from 'hooks/api';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const getCurrentMinutes = () => Math.round(new Date().getTime() / (1000 * 60));

export const useGetCartItems = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const cartItems = useSelector((state: any) => state.setting.cartItems);
  const filterDate = useSelector((state: any) => state.setting.filterDate);
  const cartAssetIds = React.useRef<string[]>([]);
  const cartAssetIdsMinutes = React.useRef(0);

  const pickupdate = getDateFromMoment(filterDate.pickupDate);
  const pickupTime = filterDate.pickupTime || '';
  const returnDate = getDateFromMoment(filterDate.returnDate);
  const returnTime = filterDate.returnTime || '';
  const assetId = cartItems?.[0]?.assetId;

  const { data: accessTokenData } = useGetAccessToken();
  const accessToken = accessTokenData?.data?.accessToken;
  const enabled = Boolean(accessToken);

  React.useEffect(() => {
    if (!enabled) return;

    try {
      const localStorageAssetIds = localStorage.getItem('CartAssetIds') || '[]';
      const localStorageAssetIdsTime = localStorage.getItem('CartAssetIdsMinutes');

      cartAssetIds.current = JSON.parse(localStorageAssetIds);
      cartAssetIdsMinutes.current = Number(localStorageAssetIdsTime) || 0;
    } catch (err) {}

    if (cartAssetIdsMinutes.current && getCurrentMinutes() - cartAssetIdsMinutes.current > 60) {
      localStorage.setItem('CartAssetIds', '[]');
      localStorage.setItem('CartAssetIdsMinutes', '0');
      cartAssetIds.current = [];
      cartAssetIdsMinutes.current = 0;
    }

    if (assetId && !cartAssetIds.current.length) {
      localStorage.setItem('CartAssetIds', JSON.stringify([assetId]));
      localStorage.setItem('CartAssetIdsMinutes', getCurrentMinutes().toString());
      return;
    }

    if (!assetId && cartAssetIds.current.length) {
      const fetchEquipInfo = async () => {
        const { data } = await assetsApi.getAssetDetail(cartAssetIds.current[0]);
        if (data && data.status === 'OK') {
          return data;
        }
      };
      dispatch(setIsLoading(true));
      fetchEquipInfo()
        .then((res) => {
          dispatch(setAddCart(res));
        })
        .catch((err) => {
          localStorage.removeItem('CartAssetIds');
        })
        .finally(() => {
          dispatch(setIsLoading(false));
        });
    }
  }, [assetId, enabled]);


  React.useEffect(() => {
    if (!enabled) return;

    const fetchEquipFee = async (id: string) => {
      const { data } = await assetsApi.getBookingFee(
        id,
        pickupdate,
        pickupTime,
        returnDate,
        returnTime,
      );
      if (data && data.status === "OK") {
        return data;
      }
    };

    if (
      assetId &&
      filterDate.pickupDate &&
      filterDate.returnDate &&
      ['/cart', '/checkout'].includes(pathname)
    ) {
      dispatch(setIsLoading(true));
      fetchEquipFee(assetId)
        .then((res) => {
          dispatch(setEquipFee(res));
        })
        .catch(e => {})
        .finally(() => {
          dispatch(setIsLoading(false));
        });
	  }
  }, [
    assetId,
    pickupdate,
    pickupTime,
    returnDate,
    returnTime,
    pathname,
    enabled,
  ]);
};
